import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
// import {} from '@va/core-library/formula-bar'

@Component({
  selector: "app-formula-bar",
  templateUrl: "./formula-bar.component.html",
  styleUrls: ["./formula-bar.component.scss"],
})
export class FormulaBarComponent {
  dpCallObj: any;
  isReady: boolean = false;
  apiEP: string = window.apiUrl;
  constructor(protected route: ActivatedRoute) {}

  ngOnInit() {
    const queryParams = this.route.snapshot.queryParams;
    this.isReady = false;
    this.dpCallObj = {};
    this.setDpParams("ticker", queryParams);
    this.setDpParams("dp", queryParams);
    this.setDpParams("cut", queryParams);
    this.setDpParams("period", queryParams);
    this.setDpParams("source", queryParams);
    this.setDpParams("shouldLog", queryParams);
    this.setDpParams("get_nmv_link", queryParams);
    this.setDpParams("extras", queryParams);
    this.setDpParams("growthType", queryParams);
    this.setDpParams("historicalRevision", queryParams);
    this.setDpParams("isAddin", queryParams);
    this.setDpParams("revisionDate", queryParams);
    this.setDpParams("is_universalsliid", queryParams);
    this.setDpParams("tpr_page", queryParams);
    this.setDpParams("incl_sources", queryParams);
    this.setDpParams("excl_sources", queryParams);
    this.setDpParams("parent_prefix", queryParams);
    this.setDpParams("excl_reaffirm_broker_consensus", queryParams);
    this.setDpParams("partial_entitled_sid", queryParams);
    this.isReady = true;
  }

  setDpParams(name, params) {
    if (params[name]) {
      this.dpCallObj[name] = params[name];
    }
  }
}
